import React, { useEffect, useState } from "react";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  ConstructionTypeOptions,
  landUseZoneOptions,
  natureOfConstructionOptionComp,
  planOnOptions,
  plotSubUseOptions,
  plotUseOptions,
  ResidentialUseList,
  yesOrNo,
} from "../../../../TCPForms/data";
import { Col, Container, Row } from "react-bootstrap";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { SummaryCard } from "../../../components/StyledComponent";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import DxfFileUploader from "../../../reusableComponents/DxfFileUploader";

const SubStep1 = ({ formData, setFormData, handleSubTabChange, initFormMTDocs, setShowToast, isEmployee }) => {
  console.log(formData, "formDatatattata");
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [file, setFile] = useState(null);
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const watchorientType = watch("tod.orientDevelopment");
  const edcrData = Digit.SessionStorage.get("EDCR_CREATE")?.[0];
  const fastPASData = Digit.SessionStorage.get("FASTPAS_ID");
  const watchProposalType = formData?.proposalType;
  const watchisSpecialProject = formData?.isSpecialProject;
  const watchTypeOfProject = formData?.typeOfProject;
  const watchPlotSubdivided = formData?.plotSubdivided;
  const watchNeedComp = formData?.needCompounding;
  const watchplotLeaseHold = formData?.plotLeaseHold;
  const watchNatureOfConstruction = formData?.natureOfConstruction;
  const watchisRevised = formData?.isRevised;
  const watchNoOfPLots = formData?.noOfPlots;
  const watchisApprovedLayout = formData?.isApprovedLayout;
  const watchisSetbackRequired = formData?.isSetbackRequired;
  const schemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
  const watchPlanOn = formData?.planOn;
  const watchProjectType = formData?.projectType;
  const watchbuildingClassification = formData?.buildingClassification;
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const totalPlots = parseInt(watchNoOfPLots, 10) || 0;
  const dispatch = useDispatch();
  const { resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  // Calculate the number of full rows (each with 5 plots) and any remaining plots
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;

  // Generate an array representing the plot inputs
  const plotInputs = Array.from({ length: totalPlots }, (_, index) => ({
    index: index,
  }));
  const clearAllData = () => {
    resetFormMTDocs();
    Digit?.SessionStorage.del("FORM12_CURRENT_TAB");
    Digit?.SessionStorage.del("ScrutinyDetails");
    Digit?.SessionStorage.del("EDCR_CREATE");
    Digit?.SessionStorage.del("FASTPAS_ID");
  };
  useEffect(() => {
    const handleBackButton = () => {
      clearAllData();
    };
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  });
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  useEffect(() => {
    const data = Digit.SessionStorage.get("FASTPAS_ID");
    const updatedDocuments = data?.documents?.map((doc) => ({
      ...doc,
      documentRemarks: null,
      documentStatus: null,
    }));

    if (data) {
      const newFormData = {
        ...formData,
        landInfo: {
          ...data.landInfo,
          address: formData?.landInfo?.address,
        },
        land_Id: data?.land_Id,
        selectedCity: data?.selectedCity,
        selectedUnit: data?.selectedUnit,
        documents: updatedDocuments,
        descriptionOfLand: data?.descriptionOfLand,
        nocDetails: data?.nocDetails,
        khasraDetails: data?.khasraDetails,
      };
      setFormData((prevState) => ({
        ...prevState,
        ...newFormData,
      }));
      initFormMTDocs(updatedDocuments);
    }
  }, []);
  const activityAsPerMap = formData?.primaryUse;
  const watchlandUseType = formData?.zoneType;
  const activityProposed = formData?.activityProposed;
  const developmentArea = formData?.constructionType;
  const landArea = formData?.plotArea;
  const schemeTypes = formData?.descriptionOfLand?.schemeType;
  console.log({ activityAsPerMap, activityProposed }, typeof activityAsPerMap, typeof activityProposed, "activityAsPerMap");

  //let riskType = "HIGH_NIVESH";
  const determineRiskType = (formData) => {
    const {
      primaryUse: activityAsPerMap,
      activityProposed,
      constructionType: developmentArea,
      plotArea: landArea,
      descriptionOfLand: { schemeType: schemeTypes } = {},
    } = formData || {};

    // Default value
    let riskType = "HIGH_NIVESH";

    // Only process if activity is Residential
    if (activityAsPerMap === "Residential") {
      // Group housing types (all HIGH_NIVESH)
      const groupHousingTypes = new Set(["Multi Unit", "Group Housing", "EWS Group Housing", "LIG Group Housing", "Affordable Group Housing"]);

      // Row house types
      const rowHouseTypes = new Set(["Row Houses", "Semi Detached", "Detached"]);

      if (groupHousingTypes.has(activityProposed)) {
        riskType = "HIGH_NIVESH";
        console.log(riskType, "Group housing case");
      } else if (rowHouseTypes.has(activityProposed)) {
        if (developmentArea === "Built Up") {
          if (landArea <= 100) {
            riskType = "LOW";
          } else if (schemeTypes === "Non Scheme") {
            riskType = "HIGH";
          }
        } else {
          if (schemeTypes === "Non Scheme") {
            riskType = "HIGH";
          } else if (schemeTypes === "Scheme") {
            riskType = "LOW";
          }
        }
      }
    }

    return riskType;
  };
  const onSubmit = (data) => {
    handleSubTabChange(1, formData);
  };
  if (!isEmployee && applicationFlow === null) {
    return <DepartmentSelector />;
  }
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("General Information")}</h2>
          </div>

          <Container fluid className="formInputContainer">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS ID"
                  name="land_Id"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.land_Id || fastPASData?.land_Id}
                />
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={landUseZoneOptions}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={ResidentialUseList}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.subZoneType}
                  type="selectInput"
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={plotUseOptions}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={plotSubUseOptions}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed || formData?.descriptionOfLand?.activityProposed}
                  type="selectInput"
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={planOnOptions}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="planOn"
                  defaultValue={formData?.planOn}
                  type="selectInput"
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  {" "}
                  <InputWrapper
                    label={"Other Proposed Site"}
                    control={control}
                    placeholder={t("Enter Proposed SIte")}
                    name="otherSchemeName"
                    mandatory
                    defaultValue={formData?.otherSchemeName}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction No.")}
                  control={control}
                  placeholder={t("Enter layout sanction number")}
                  name="layoutsanctionNumber"
                  defaultValue={formData?.layoutsanctionNumber}
                  type="textInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction Date")}
                  control={control}
                  placeholder={t("Enter Layout Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                />
              </Col>
            </Row>
            <Row>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={t("Development Area")}
                    control={control}
                    placeholder={t("Select Development Area Type")}
                    data={ConstructionTypeOptions}
                    name="constructionType"
                    mandatory
                    defaultValue={formData?.constructionType}
                    type="selectInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={natureOfConstructionOptionComp}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  type="selectInput"
                />
              </Col>
              {watchNatureOfConstruction !== "New" ? (
                <Col>
                  <InputWrapper
                    label={t("Prev File No")}
                    control={control}
                    placeholder={t("Enter File No")}
                    name="prevFileNo"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.prevFileNo}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            <Row>
              {formData?.schemeName ? (
                <Col>
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="textInput"
                    mandatory={!schemeType}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              <Col>
                {" "}
                <InputWrapper
                  label={t("Tehsil")}
                  control={control}
                  placeholder={t("Enter Tehsil")}
                  name="tehsil"
                  defaultValue={formData?.tehsil}
                  type="textInput"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Revenue Village/Colony Name"
                  control={control}
                  placeholder="Enter Revenue Village"
                  defaultValue={formData?.revenueVillage}
                  name={`revenueVillage`}
                  type="textInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Sector/Pocket No.")}
                  control={control}
                  placeholder={t("Enter Sector/Pocket No.")}
                  name="sectorNo"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Khasra No.")}
                  control={control}
                  placeholder={t("Enter Khasra No.")}
                  name="khasraNo"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.khasraNo}
                  type="textInput"
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Standard Type Design")}`}
                  name="proposalType"
                  defaultValue={formData?.proposalType}
                  type="radioButton"
                  data={yesOrNo}
                  mandatory
                />
              </Col>
              {schemeType ? (
                <Col>
                  <InputWrapper
                    label={t("Plot No")}
                    control={control}
                    placeholder={t("Enter Plot no")}
                    name="plotNo"
                    mandatory
                    defaultValue={formData?.plotNo}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction date of layout")}
                    control={control}
                    placeholder={t("Enter Sanction date Of layout")}
                    name="sanctionDate"
                    defaultValue={formData?.sanctionDate}
                    type="datePicker"
                  />
                </Col>
              )}
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction number of layout")}
                    control={control}
                    placeholder={t("Enter Sanction number Of layout")}
                    name="sanctionNumber"
                    defaultValue={formData?.sanctionNumber}
                    type="textInput"
                  />
                </Col>
              )}
            </Row>

            {/* No of Plots Mapping */}

            {watchProposalType === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("No. Of Plots")}
                    control={control}
                    placeholder={t(" No. Of PLots")}
                    name="noOfPlots"
                    defaultValue={formData?.noOfPlots}
                    type="textInput"
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            {Array.from({ length: fullRows }).map((_, rowIndex) => (
              <Row key={rowIndex}>
                {plotInputs.slice(rowIndex * 3, rowIndex * 3 + 3).map((plot) => (
                  <Col key={`plot-${plot.index}`}>
                    <InputWrapper
                      control={control}
                      placeholder={t("Enter Plot No")}
                      name={`plotNumbers${plot.index}`}
                      hasLabel={false}
                      maxLength={15}
                      defaultValue={formData?.plotNumbers?.[plot.index]}
                      type="textInput"
                    />
                  </Col>
                ))}
              </Row>
            ))}

            {remainingPlots > 0 && (
              <Row key={fullRows}>
                {plotInputs.slice(fullRows * 3).map((plot) => (
                  <Col key={`plot-${plot.index}`}>
                    <InputWrapper
                      control={control}
                      placeholder={t("Enter Plot No")}
                      name={`plotNumbers${plot.index}`}
                      maxLength={15}
                      hasLabel={false}
                      defaultValue={formData?.plotNumbers?.[plot.index]}
                      type="textInput"
                    />
                  </Col>
                ))}
              </Row>
            )}

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Project Type")}`}
                  placeholder={"Select Project Type"}
                  name="buildingClassification"
                  defaultValue={formData?.buildingClassification}
                  type="textInput"
                  mandatory
                />
              </Col>
              <Col>
                {watchbuildingClassification === "Others" && (
                  <Col>
                    <InputWrapper
                      label={t("Other Project")}
                      control={control}
                      placeholder={t("Enter  Name")}
                      name="otherbuildingClass"
                      mandatory
                      defaultValue={formData?.otherbuildingClass}
                      type="textInput"
                    />
                  </Col>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={yesOrNo}
                  label={`${t("Special Project type")}`}
                  name="isSpecialProject"
                  defaultValue={formData?.isSpecialProject}
                  type="radioButton"
                  mandatory
                />
              </Col>
              <Col>
                {" "}
                {(watchlandUseType !== "Residential" || activityAsPerMap !== "Residential") && (
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={t("If Community Parking Provided")}
                    placeholder={t("Select Community Parking")}
                    name="communityParking"
                    defaultValue={formData?.communityParking}
                    type="selectInput"
                  />
                )}
              </Col>
            </Row>

            <Row>
              {watchisSpecialProject === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Select Condition of Project")}
                    control={control}
                    placeholder={t("Select Project Type")}
                    name="projectType"
                    defaultValue={formData?.projectType}
                    type="selectInput"
                  />
                </Col>
              )}
              {watchProjectType === "Other" && (
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Other Project")}
                    control={control}
                    placeholder={t("Enter  Name")}
                    name="otherProjectName"
                    mandatory
                    defaultValue={formData?.otherProjectName}
                    type="textInput"
                  />
                </Col>
              )}
            </Row>
            {watchisSpecialProject === "yes" &&
              (watchProjectType === "Building Design as per standard Drawing" ||
                watchProjectType === "Standard condition as per Lease deed/freehold deed") && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Ground Coverage")}
                      placeholder={t("Enter Ground Coverage")}
                      name="groundCoverage"
                      defaultValue={formData?.groundCoverage}
                      type="textInput"
                    />
                  </Col>

                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("FAR")}
                      placeholder={t("Enter FAR")}
                      name="far"
                      defaultValue={formData?.far}
                      type="textInput"
                    />
                  </Col>
                </Row>
              )}

            {watchisSpecialProject === "yes" &&
              (watchProjectType === "Building Design as per standard Drawing" ||
                watchProjectType === "Standard condition as per Lease deed/freehold deed") && (
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Building Height")}
                      placeholder={t("Enter Building Height")}
                      name="buildingHeight"
                      defaultValue={formData?.buildingHeight}
                      type="textInput"
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Please specify if any other condition")}
                      placeholder={t("Enter condition")}
                      name="anyotherCondition"
                      defaultValue={formData?.anyotherCondition}
                      type="textInput"
                    />
                  </Col>
                </Row>
              )}

            {watchisSpecialProject === "yes" &&
              (watchProjectType === "Building Design as per standard Drawing" ||
                watchProjectType === "Standard condition as per Lease deed/freehold deed") && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Front")}
                      control={control}
                      placeholder={t("Enter Front")}
                      name="setbackFronts"
                      mandatory
                      maxLength={15}
                      defaultValue={formData?.previousSetbackFront || formData?.setbackFronts}
                      type="textInput"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Rear")}
                      control={control}
                      placeholder={t("Enter Rear")}
                      name="setbackRears"
                      mandatory
                      maxLength={15}
                      defaultValue={formData?.previousSetbackRear || formData?.setbackRears}
                      type="textInput"
                    />
                  </Col>
                </Row>
              )}

            {watchisSpecialProject === "yes" &&
              (watchProjectType === "Building Design as per standard Drawing" ||
                watchProjectType === "Standard condition as per Lease deed/freehold deed") && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Left")}
                      control={control}
                      placeholder={t("Enter Left")}
                      name="setbackSide1"
                      mandatory
                      maxLength={15}
                      defaultValue={formData?.previousSetbackSide1 || formData?.setbackSide1}
                      type="textInput"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Right")}
                      control={control}
                      placeholder={t("Enter Right")}
                      name="setbackSide2"
                      mandatory
                      maxLength={15}
                      defaultValue={formData?.previousSetbackSide2 || formData?.setbackSide2}
                      type="textInput"
                    />
                  </Col>
                </Row>
              )}

            {/* Mapping req */}

            <Row>
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (
                  <Col>
                    <InputWrapper
                      label={t("Is Your Plot Sub-division")}
                      control={control}
                      name="plotSubdivided"
                      data={yesOrNo}
                      defaultValue={formData?.plotSubdivided}
                      type="radioButton"
                    />
                  </Col>
                )}
            </Row>
            <Row>
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") &&
                watchPlotSubdivided === "no" && (
                  <Col>
                    <InputWrapper
                      label={t("Does existing building require any compounding ?")}
                      control={control}
                      name="needCompounding"
                      data={yesOrNo}
                      defaultValue={formData?.needCompounding}
                      type="radioButton"
                    />
                  </Col>
                )}
            </Row>
            <Row>
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") &&
                watchPlotSubdivided === "no" &&
                watchNeedComp === "no" && (
                  <Col>
                    <InputWrapper
                      label={t("Is your plot Lease hold ?")}
                      control={control}
                      name="plotLeaseHold"
                      data={yesOrNo}
                      defaultValue={formData?.plotLeaseHold}
                      type="radioButton"
                    />
                  </Col>
                )}
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") &&
                watchPlotSubdivided === "no" &&
                watchNeedComp === "no" &&
                watchplotLeaseHold === "yes" && (
                  <Col>
                    <FileUploader
                      label={"Noc For Lease Hold"}
                      control={control}
                      name="leaseholdNOC"
                      validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                      required
                      isMandatory
                      tab={1}
                    />
                  </Col>
                )}
            </Row>
          </Container>
        </div>
        {!isEmployee && formData?.edcrNumber && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Drawing")}</h2>
            </div>
          </div>
        )}
        {!isEmployee && formData?.edcrNumber && (
          <SummaryCard className="formContainer">
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                  <Grid item xs={12} md={6}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2} style={{ padding: "1rem" }}>
                      <Grid item xs={6}>
                        <strong>{"Drawing Pdf"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <strong>{"Plan Report"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.planReport, "_blank")}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <strong>{"DXF File"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <img
                          src={"https://i.imgur.com/GDoAGny.png"}
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.dxfFile, "_blank")}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}
        <div className="formContainer bg-white">
          <FormControlLabel
            style={{ padding: "10px 15px" }}
            control={
              <Checkbox
                name="declaration"
                control={control}
                onChange={handleDeclarationChange}
                rules={{ required: "You must agree to the terms and conditions" }}
              />
            }
            label={
              <span>
                I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.
                <br /> The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information present in
                the file shall not be the responsibility of the EDCR Engine.
              </span>
            }
          />
        </div>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Upload DXF File")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form custom-upload new-custom-uploader">
            <Row>
              <DxfFileUploader
                control={control}
                name="file"
                label="Upload Building Plan Drawing"
                validationMsg="(dxf only and Max file Size 300 MB)"
                isMandatory
                required
                tab={3}
                setFile={setFile}
                maxFiles={1}
              />
            </Row>
          </Container>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              {/* <ButtonWrapper variant="contained" color="error" size="medium" label="Prev" sx={{ backgroundColor: "#CCC" }} onClick={() => reset()} /> */}
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                disabled={!declarationChecked}
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};
export default SubStep1;
